import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const IngresoReducer = createReducer(INITIAL_STATE, (builder) => {
  /**
   * Actualizar form de cierre de cuentas
   */
  builder
    .addCase(Types.FORM_CIERRE_CUENTAS_LOADING, (state) => {
      state.formCierreCuentasLoading = true;
    })
    .addCase(Types.FORM_CIERRE_CUENTAS_SUCCESS, (state, action) => {
      const { formCierreCuentasData } = action;
      state.formCierreCuentasData = formCierreCuentasData;
      state.formCierreCuentasLoading = false;
      state.consultarIngresoLoading = false;
      state.getProcedimientosPermitidosCierreCuentasLoading = false;
      state.validarProcedimientoCierreCuentasLoading = false;
      state.eliminarProcedimientoCierreCuentasLoading = false;
      state.consultarReclamantesLoading = false;
      state.cerrarCuentaClinicaLoading = false;
      state.consultarDetalleCierreCuentaLoading = false;
    });

  /**
   * Consultar un ingreso
   */
  builder.addCase(Types.CONSULTAR_INGRESO_LOADING, (state) => {
    state.consultarIngresoLoading = true;
  });

  /**
   * Consultar detalle de un cierre de cuenta
   */
  builder.addCase(Types.CONSULTAR_DETALLE_CIERRE_CUENTA_LOADING, (state) => {
    state.consultarDetalleCierreCuentaLoading = true;
  });

  /**
   * Consultar procedimientos permitidos para cierre de cuentas
   */
  builder.addCase(
    Types.GET_PROCEDIMIENTOS_PERMITIDOS_CIERRE_CUENTAS_LOADING,
    (state) => {
      state.getProcedimientosPermitidosCierreCuentasLoading = true;
    }
  );

  /**
   * Agregar procedimiento cierre de cuentas
   */
  builder.addCase(
    Types.VALIDAR_PROCEDIMIENTO_CIERRE_CUENTAS_LOADING,
    (state) => {
      state.validarProcedimientoCierreCuentasLoading = true;
    }
  );

  /**
   * Eliminar procedimiento cierre de cuentas
   */
  builder.addCase(
    Types.ELIMINAR_PROCEDIMIENTO_CIERRE_CUENTAS_LOADING,
    (state) => {
      state.eliminarProcedimientoCierreCuentasLoading = true;
    }
  );

  /**
   * Consultar un reclamantes
   */
  builder.addCase(Types.CONSULTAR_RECLAMANTES_LOADING, (state) => {
    state.consultarReclamantesLoading = true;
  });

  /**
   *  Cerrar cuenta clinica
   */
  builder.addCase(Types.CERRAR_CUENTA_CLINICA_LOADING, (state) => {
    state.cerrarCuentaClinicaLoading = true;
  });

  /**
   *  Consultar cierres cuentas
   */
  builder.addCase(Types.CONSULTAR_CIERRES_CUENTAS_LOADING, (state) => {
    state.consultarCierresCuentasLoading = true;
  });

  /**
   * Actualizar form de consulta de cierres de cuentas
   */
  builder
    .addCase(Types.FORM_CONSULTA_CIERRES_CUENTAS_LOADING, (state) => {
      state.formConsultaCierresCuentasLoading = true;
    })
    .addCase(Types.FORM_CONSULTA_CIERRES_CUENTAS_SUCCESS, (state, action) => {
      const { formConsultaCierresCuentasData } = action;
      state.formConsultaCierresCuentasData = formConsultaCierresCuentasData;
      state.formConsultaCierresCuentasLoading = false;
      state.consultarCierresCuentasLoading = false;
    });
});
